<template>
  <el-dropdown class="agent-destination-frame">
    <span class="el-dropdown-link">
      <font-awesome-icon
        :icon="['fa', 'list-tree']"
        size="2x"
      ></font-awesome-icon>
      <font-awesome-icon icon="chevron-down" style="margin-left: 3px" />
    </span>
    <template #dropdown>
      <div v-loading="loading">
        <div style="padding: 8px;">
        <el-button
         style="width: 90%; margin: 2px 8px 2px 8px;"
         :size="buttonSize"
         v-for="q in userQueues"
         :key="q.queue_id"
         :type="q.selected ? 'primary' : 'default'"
         @click="saveQueue(q.queue_id, !q.selected)"
         >
         {{q.name}}
         </el-button>
        </div>
      </div>

      <!--
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(dest, index) in getDialDestinations"
          v-bind:key="index"
          class="dropdown-item"
          :disabled="dest.id == currentDest.id"
          @click.native="changeDest(dest)"
        >
          <span class="mr-2">{{ dest.name }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
      -->
    </template>
  </el-dropdown>
</template>
<script>
import { mapGetters } from 'vuex';

import AgentService from 'src/services/agentService';

export default {
  name: 'UserQueueSelect',
  props: {
    userId: {
      type: Number,
      required: true,
    },
    buttonSize: {
      type: String,
      'default': 'small',
    },
    /*
     button size only works with el-checkmark-group
     so using el-button in html until the bug is fixed
     https://github.com/element-plus/element-plus/issues/14689
     */
  },
  computed: {
    ...mapGetters('team', ['getUserById', 'getTeam']),
    ...mapGetters('queues', ['getQueues']),
  },
  async created() {
    this.loadQueueSelect();
  },
  watch: {
    userId(n) {
      this.loadQueueSelect();
      // Load the current queues for this user
    },
  },
  data() {
    return {
      userQueues: [],
    };
  },
  methods: {
    async loadQueueSelect() {
      this.loading = true;
      const userQueues = await AgentService.getQueueSelect();
      const validQueues = [];
      // Only display valid queues
      for (const u of userQueues) {
        const q = this.getQueues.find(q => q.id == u.queue_id);
        if (q) {
          u.name = q.name;
          validQueues.push(u);
        }
      }
      this.userQueues = validQueues;
      this.loading = false;

    },
    async saveQueue(queueId, state) {
      // Id is user_queue.id not queue_id
      this.userQueues.find((uq) => uq.queue_id == queueId).selected = state;
      const payload = this.userQueues.map(uq => ({user_id: uq.user_id, queue_id: uq.queue_id, selected: uq.selected}));

      await AgentService.setQueueSelect(payload);
      // if all is good we need to update the queue state in the queue store
    },
  },
};
</script>
